import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatTime } from "../utils/format";
import { getOpeningStatus } from "../utils/openingHours";
import { openingHoursSelector } from "../modules/store/selectors";

function OpenSign({ children }) {
  const openingHours = useSelector(openingHoursSelector);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = window.setInterval(() => setNow(new Date()), 30 * 1000);
    return () => window.clearInterval(interval);
  }, []);

  const { isOpen, activeOpeningHour, todayOpeningHours } = getOpeningStatus(
    openingHours,
    now,
  );
  const displayedHours =
    isOpen && activeOpeningHour ? [activeOpeningHour] : todayOpeningHours;

  const openHours = displayedHours
    .map((w) => `${formatTime(w.start)} — ${formatTime(w.end)}`)
    .join(", ");

  if (isOpen) {
    return children({ text: `Otwarte ${openHours}`, isOpen: true });
  }

  if (todayOpeningHours.length === 0) {
    return children({ text: "Teraz zamknięte", isOpen: false });
  }

  return children({ text: `Zamknięte ${openHours}`, isOpen: false });
}

export default OpenSign;
